import Reorder from './reorder.element.js';

export default Reorder;

Reorder.define('wje-reorder', Reorder);
